/**
 * @param state {object} Domain state
 * @param searchRequest {object} Search request
 * @returns {object} Updated domain state
 */
export const saveSearchRequestReducer = (state, searchRequest) => {

    state.searchRequests[searchRequest.localId] = searchRequest;
    state.lastSearchRequest = searchRequest;

    return state;
};
